import { render, staticRenderFns } from "./AddSurgeryItemPopup.vue?vue&type=template&id=66ba7e12"
import script from "./AddSurgeryItemPopup.vue?vue&type=script&lang=js"
export * from "./AddSurgeryItemPopup.vue?vue&type=script&lang=js"
import style0 from "./AddSurgeryItemPopup.vue?vue&type=style&index=0&id=66ba7e12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports